import React from 'react'

export default function AboutUs() {
  return (
    <div className='container'>
      About Us
    </div>
  )
}
